import { FeedFilter } from 'api/KnowledgeAPI';
import { create } from 'zustand';

type TabFilters = {
  [tab: string]: FeedFilter[];
};

type PostsFiltersStore = {
  filters: Record<string, TabFilters>;
  resetFilters: (companyId?: string, tab?: string) => void;
  setFilters: (companyId: string, filters: FeedFilter[], tab: string) => void;
};

const useSearchFiltersStore = create<PostsFiltersStore>((set) => ({
  filters: {},
  resetFilters: (companyId, tab) =>
    set((prevState) => {
      if (!companyId) return { filters: {} };

      if (tab) {
        const { [tab]: _, ...remainingTabs } = prevState.filters[companyId] || {};

        return {
          filters: {
            ...prevState.filters,
            [companyId]: remainingTabs,
          },
        };
      }

      const { [companyId]: _, ...remainingCompanies } = prevState.filters;
      return { filters: remainingCompanies };
    }),

  setFilters: (companyId, filters, tab) =>
    set((prevState) => {
      const existingFilters = prevState.filters[companyId] || {};

      return {
        filters: {
          ...prevState.filters,
          [companyId]: {
            ...existingFilters,
            [tab]: filters,
          },
        },
      };
    }),
}));

export default useSearchFiltersStore;
